// extracted by mini-css-extract-plugin
export var askRedoIcon = "_a-f";
export var askRedoTag = "_a-8";
export var askRedoText = "_a-e";
export var brandGroup = "_a-2";
export var chevron = "_a-p";
export var chevronActive = "_a-q";
export var chevronDown = "_a-l";
export var divider = "_a-r";
export var exitIcon = "_a-b";
export var exitTag = "_a-7";
export var exitText = "_a-d";
export var header = "_a-0";
export var logo = "_a-4";
export var navBar = "_a-1";
export var productIcon = "_a-9";
export var productName = "_a-c";
export var productTag = "_a-5";
export var profileAvatar = "_a-h";
export var profileGroup = "_a-g";
export var profileImage = "_a-i";
export var profileInitials = "_a-j";
export var progressFill = "_a-t";
export var progressTrack = "_a-s";
export var rightGroup = "_a-3";
export var stepLabel = "_a-n";
export var stepLabelActive = "_a-o";
export var stepLabels = "_a-m";
export var storeName = "_a-k";
export var themeIcon = "_a-a";
export var themeTag = "_a-6";